// extracted by mini-css-extract-plugin
export default {"catCard":"CatCard_catCard__rCuDT","catCard__image":"CatCard_catCard__image__wAZ72","catCard__name":"CatCard_catCard__name__h7TNL"};